module.exports = __webpack_public_path__ + "static/media/removeField.72f4c92e.svg";